module.exports = __webpack_public_path__ + "static/media/07PerformancePhotos.2acc5c7b.jpeg";